import React, { Fragment } from "react";
import Select from "react-select";
import loadImage from "blueimp-load-image";
import PendingIconImage from "../../../assets/media/icons/pending.png";
import IconStore from "../../Chatbot/components/IconStore";
import "./index.css";
import Firebase from "../../../firebasehelper";
import { CurrencyOptions } from "../../../Constants/retailer";
import { user_actions } from "../../../Utils/Constants";
import { pages } from "../../../Constants/selections";
class EditBrandTokenEarning extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      description: "",
      token: 0,
      premier_token: "",
      loading: true,
      territory: "UK",
      img_content: "",
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        icon: this.props.icon,
        img_url: this.props.img_url,
        page: { value: this.props.page, label: this.props.page },
        user_action: user_actions.find(
          (item) => item.value === this.props.action
        ),
        brand: this.props.brand,
        territory: this.props.territory,
        title: this.props.title || "",
        description: this.props.description || "",
        token: this.props.token || 0,
        premier_token: this.props.premier_token
          ? `${CurrencyOptions[this.props.territory]}${
              this.props.premier_token
            }`
          : "",
      });
    }
  }
  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };
  onChangePremierToken = ({ target: { value } }) => {
    const { territory } = this.state;
    let newValue = value.split(".");
    if (newValue.length > 1) {
      newValue =
        newValue.slice(0, -1).join("") + "." + newValue[newValue.length - 1];
    } else {
      newValue = value;
    }
    const countDecimals = function (number) {
      if (Math.floor(number) === Number(number)) return 0;
      return number.toString().split(".")[1].length || 0;
    };
    let number = Number(newValue.replace(/[^0-9\.]+/g, ""));
    const decimalPoints = countDecimals(newValue);
    if (decimalPoints >= 3) {
      number = number * 10;
    } else {
      number = number / Math.pow(10, 2 - decimalPoints);
    }
    this.setState({
      premier_token: `${CurrencyOptions[territory]}${number.toFixed(2)}`,
    });
  };

  onSelectImage = (icon) => {
    this.setState({ icon, showChooseIcon: false });
  };

  onRequestUpdate = () => {
    let { title, description, token, premier_token, page, icon, user_action } =
      this.state;
    const { onSave } = this.props;
    // const { onApprove } = this.props;
    if (premier_token) premier_token = premier_token.substring(1);
    onSave({
      title,
      description,
      token,
      premier_token,
      page: page.value,
      icon,
      action: user_action.value,
    });
    this.setState({
      title: "",
      description: "",
      token: 0,
      premier_token: "",
      page: null,
      user_action: null,
    });
  };
  checkValidation = () => {
    let { title, description, token, premier_token, page, icon } = this.state;
    return title && description && page && icon && (token || premier_token);
  };
  render() {
    const {
      title,
      description,
      token,
      premier_token,
      page,
      icon,
      showChooseIcon,
      territory,
      brand,
      user_action,
    } = this.state;
    return (
      <div
        className="modal fade token-earning-dialog"
        id="edit_token_earning_modal"
        tabIndex="-2"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content add-token-earning-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit token earning</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 brand-token-earning-dialog-body">
              {!brand && (
                <p style={{ width: "100%" }}>
                  This is standard task made by super admin.<br></br> You can't
                  update this.
                </p>
              )}
              {brand && (
                <Fragment>
                  <div className="icon-container">
                    <button
                      type="button"
                      className="btn btn-warning choose-icon-btn"
                      onClick={() => {
                        this.setState({ showChooseIcon: true });
                      }}
                    >
                      Choose Icon
                    </button>
                    <img
                      src={icon ? icon : PendingIconImage}
                      width="40"
                      alt="icon"
                    />
                  </div>
                  {showChooseIcon && (
                    <IconStore onSelectImage={this.onSelectImage} />
                  )}
                  <p className="token-earning-property-title">
                    Token Earning Title
                  </p>
                  <input
                    className="form-control form-control-md form-control-alt"
                    onChange={this.handleInputChange("title")}
                    maxLength="24"
                    value={title}
                  />
                  <p className="bottom-text">Max characters: 24</p>
                  <p className="token-earning-property-title">
                    Token Earning Description
                  </p>
                  <textarea
                    className="form-control form-control-md form-control-alt"
                    onChange={this.handleInputChange("description")}
                    value={description}
                  />
                  <p className="token-earning-property-title">
                    Shopping Token Value
                  </p>
                  <input
                    type="number"
                    placeholder="0"
                    className="form-control form-control-md form-control-alt"
                    onChange={this.handleInputChange("token")}
                    value={token}
                  />
                  <p className="token-earning-property-title">
                    Premier Token Value
                  </p>
                  <input
                    type="text"
                    placeholder={`${CurrencyOptions[territory]}00.00`}
                    className="form-control form-control-md form-control-alt bill-price"
                    onChange={this.onChangePremierToken}
                    value={premier_token}
                  />
                  <div className="page-action-container">
                    <div style={{ width: "45%" }}>
                      <p className="token-earning-property-title">Pages</p>
                      <div className="page-select-container">
                        <Select
                          options={Object.values(pages).map((page) => ({
                            value: page.id,
                            label: page.name,
                          }))}
                          onChange={(value) => this.setState({ page: value })}
                          value={page}
                        ></Select>
                      </div>
                    </div>
                    <div style={{ width: "45%" }}>
                      <p className="token-earning-property-title">
                        User Actions
                      </p>
                      <div
                        className="page-select-container"
                        style={{ width: "100%" }}
                      >
                        <Select
                          options={user_actions}
                          onChange={(value) =>
                            this.setState({ user_action: value })
                          }
                          value={user_action}
                        ></Select>
                      </div>
                    </div>
                  </div>
                  <div className="token-earning-footer">
                    <button
                      className="btn"
                      disabled={!this.checkValidation()}
                      onClick={this.onRequestUpdate}
                      data-dismiss="modal"
                    >
                      Request bespoke gamification task
                    </button>
                    <p>
                      Your account manager will
                      <br />
                      respond within 24 hours.
                    </p>
                  </div>
                  {/* <div className="token-earning-footer">
                        <button className="btn"
                            disabled={!this.checkValidation()}
                            onClick={this.onSave}
                            data-dismiss="modal">
                            Save
                        </button>
                    </div> */}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditBrandTokenEarning;



// WEBPACK FOOTER //
// ./src/screens/BrandTokenEarning/EditBrandTokenEarning/index.js